import React, { useState } from 'react';
import { Button, Select, Divider } from 'antd';
import { monthString } from '../../../utils/dates';
import './print-popover.scss';

const { Option } = Select;

export const PrintPopOverContent = ({ printWeek, printMonth }) => {
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [selectedMonth, setMonth] = useState(new Date().getMonth());

  return (
    <div className="cont" style={{ display: 'flex', flexFlow: 'row', alignItems: 'stretch', margin: 8 }}>
      
      <div className="cont" style={{ alignContent: 'center', display: 'flex' }}>
        <Button type="primary" style={{ padding: 5 }} onClick={() => printWeek()}>Semanal</Button>
      </div>

      <Divider type="vertical" />

      <div className="cont" style={{ width: '100%', display: 'flex', flexFlow: 'column', justifyContent: 'center' }}>

        <Select className="cont-select" style={{ width: '100%' }} defaultValue={year} onSelect={(v) => setYear(v)}>
          <Option value="2019" key="2019">2019</Option>
          <Option value="2020" key="2020">2020</Option>
          <Option value="2021" key="2021">2021</Option>
        </Select>

        <Select className="cont-select" style={{ width: '100%' }} defaultValue={selectedMonth} onSelect={(v) => setMonth(v)}>
          {
            monthString.map((month, i) => (
              <Option value={i} key={i}>{month}</Option>
            ))
          }
        </Select>

        <Button type="primary" style={{ padding: 5 }} onClick={() => printMonth(year, selectedMonth)}>Mensual</Button>

      </div>
    </div>
  );
}